module.exports = __webpack_public_path__ + "c84ed81872cfe0b9d6b70a0dcaa20608.png";